import { createStyles } from "@mantine/core";
import useTranslation from "next-translate/useTranslation";

import { Button } from "~/domains/design-system/Button";
import Dialog from "~/domains/design-system/components/Dialog/Dialog";
import { Text } from "~/domains/design-system/Text";
import { Title } from "~/domains/design-system/Title";
import { getLinkStyles } from "~/domains/common/components/Link/Link";

import {
  ContestManageModalBody,
  ContestManageModalDelimiter,
  ContestManageModalOrderedList,
  ContestManageModalOrderedListItem,
  ContestManageModalTitle,
} from "../commonStyles";

const useStyles = createStyles((theme) => ({
  button: {
    marginTop: theme.other.spacing._32,
  },
  footer: {
    '& a': {
      ...getLinkStyles(theme),
    },
  },
}));

function RewardsProgramModal({
  isOpen,
  onClose,
  commissionerFeePercentage,
  bpFeePercentage,
}: {
  isOpen: boolean;
  onClose: () => void;
  commissionerFeePercentage: number;
  bpFeePercentage: number;
}) {
  const { classes, theme } = useStyles();
  const { t } = useTranslation('contest');

  return (
    <Dialog
      type={{
        desktop: 'modal',
        mobile: 'modal-full-screen',
      }}
      isOpen={isOpen}
      onClose={onClose}
    >
      <ContestManageModalBody>
        <ContestManageModalTitle>
          {t('manage.common.modals.rewardsProgramModal.title')}
        </ContestManageModalTitle>
        <ContestManageModalOrderedList>
          <ContestManageModalOrderedListItem>
            <div>
              <Title variant="title-large">
                {t('manage.common.modals.rewardsProgramModal.list.1.title')}
              </Title>
              <Text variant="body-large" color={theme.colors.gray2[3]}>
                {t('manage.common.modals.rewardsProgramModal.list.1.description', {
                  commissionerFeePercentage,
                })}
              </Text>
            </div>
          </ContestManageModalOrderedListItem>
          <ContestManageModalOrderedListItem>
            <div>
              <Title variant="title-large">
                {t('manage.common.modals.rewardsProgramModal.list.2.title')}
              </Title>
              <Text variant="body-large" color={theme.colors.gray2[3]}>
                {t('manage.common.modals.rewardsProgramModal.list.2.description', {
                  bpFeePercentage,
                  totalFeePercentage: bpFeePercentage + commissionerFeePercentage,
                })}
              </Text>
            </div>
          </ContestManageModalOrderedListItem>
          <ContestManageModalOrderedListItem>
            <div>
              <Title variant="title-large">
                {t('manage.common.modals.rewardsProgramModal.list.3.title')}
              </Title>
              <Text variant="body-large" color={theme.colors.gray2[3]}>
                {t('manage.common.modals.rewardsProgramModal.list.3.description')}
              </Text>
            </div>
          </ContestManageModalOrderedListItem>
        </ContestManageModalOrderedList>
        <ContestManageModalDelimiter />
        <Text
          variant="body-medium"
          color={theme.colors.gray2[3]}
          className={classes.footer}
          dangerouslySetInnerHTML={{
            __html: t('manage.common.modals.rewardsProgramModal.footer'),
          }}
        />
        <Button
          variant="primary-fill"
          fullWidth
          className={classes.button}
          onClick={onClose}
        >
          {t('manage.common.modals.rewardsProgramModal.cta')}
        </Button>
      </ContestManageModalBody>
    </Dialog>
  )
}

export default RewardsProgramModal;
